import React, {useEffect} from 'react';
import { useDataValue } from 'globals/contexts/dataContext';
import routes from 'globals/routes';
import { Link, generatePath } from 'react-router-dom';

import './contactLanding.css';
import './contactLandingMobile.css';

const ContactLanding = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];

  return <section className="contactLanding">
    <div className="coverMedia">
    {{
      video: <video className="coverVideo" src={pageContent['background']['src']} autoPlay muted playsInline loop />,
      image: <img className="coverImage" src={pageContent['background']['src']} />
    }[pageContent['background']['type']]}
    </div>
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="content">
      <div className="title" dangerouslySetInnerHTML={{
        __html: pageContent['title']
      }} />
      <a className="contacts" href={`mailto:${pageContent['contacts']}`} dangerouslySetInnerHTML={{
        __html: pageContent['contacts']
      }} />
    </div>
    <div className="followus">
      <div className="followustitle" dangerouslySetInnerHTML={{
        __html: pageContent['followtitle']
      }} />
      <div className="iconwrapper">
        {pageContent['igurl'] && <div className={`media instagram`}>
          <a href={pageContent['igurl']} target="_blank">
            <img src={`./media/instagram.png`} />
          </a>
        </div>}
        {pageContent['fburl'] && <div className={`media facebook`}>
          <a href={pageContent['fburl']} target="_blank">
            <img src={`./media/facebook.png`} />
          </a>
        </div>}
        {pageContent['airbnburl'] && <div className={`media airbnb`}>
          <a href={pageContent['airbnburl']} target="_blank">
            <img src={`./media/airbnb.png`} />
          </a>
        </div>}
        {pageContent['youtubeurl'] && <div className={`media youtube`}>
          <a href={pageContent['youtubeurl']} target="_blank">
            <img src={`./media/youtube.png`} />
          </a>
        </div>}
      </div>
    </div>
  </section>;
}

export default ContactLanding;